import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: any, pattern : any): any {
    const datePipe: DatePipe = new DatePipe(this.translateService.currentLang);
    const translatedPattern = this.translateService.instant(pattern);
    return datePipe.transform(value, translatedPattern);
  }
}